import { downloadFile } from "@/lib/data/requests/files/canonical-files";
import type { FirmFile } from "@/lib/types";
import { getFirmFileDisplayName } from "@/lib/utils/firmFile";
import { handleDownload } from "@/lib/utils/matterFile";

export async function downloadFirmFile(file: FirmFile): Promise<boolean> {
  if (file.isFolder || !file.presignedUrlKey) {
    return false;
  }

  const response = await downloadFile(file.id);

  await handleDownload(getFirmFileDisplayName(file), response.url);
  return true;
}
